<template>
    <div class="main-content">
        <div class="content">
            <div class="upper">
                <div class="title">
                    <span>Your info is exposed online, putting you at high risk!</span>
                </div>
                <p>We can help with that.</p>
            </div>
            <PrimeButton
                @click="subscribe({ type: purchaseType, for: store.person?.id })"
                label="Protect Yourself"
                class="!bg-red-600 w-full"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import { PurchaseType } from '~/types/licenses/licenses';
import { useSubscriptionHelper } from '~/composables/subscriptionHelper';

const store = usePersonStore();
const { person } = storeToRefs(store);
const { subscribe } = useSubscriptionHelper();

const purchaseType = PurchaseType.PURCHASE;
</script>
<style lang="scss" scoped>
.main-content {
    @apply flex gap-4 py-4 pr-4 pl-6 bg-red-50 items-start;
}
.content {
    @apply flex flex-col items-start gap-3 flex-1;
}
.upper {
    @apply flex flex-col gap-0.5 items-start flex-1 w-full;

    p {
        @apply text-zinc-700 font-inter text-sm font-normal leading-5;
    }
}
.title {
    @apply flex justify-between items-center w-full;

    span {
        @apply text-zinc-950 font-inter text-sm font-semibold leading-5;
    }
}
.dont-show {
    @apply text-zinc-600 font-inter text-sm font-semibold leading-5;
}
</style>
